import {
  eachWeekOfIntervalWithOptions,
  formatISO,
  getDay,
  startOfDay,
} from "date-fns/fp";
import { map, pipe } from "ramda";

// creates an array of floating week keys for the given calendar interval in local (browser) timezone
// weekStartsOn is today, so for one week interval we do just one fetch
export const getFetchFrameKeys = ({
  calendarInterval,
  weekStartsOn = getDay(startOfDay(new Date())),
  timeZone,
}) => {
  const floatingWeekKeys = pipe(
    eachWeekOfIntervalWithOptions({
      weekStartsOn,
    }),
    map(formatISO),
  )(calendarInterval);
  return floatingWeekKeys;
};
